const deepGet = require('lodash/get')

const findShipment = require('../../shipment/shipment-find')
const { listForLocations } = require('../../product/api/read/list-for-locations')
const { bulkTranslateShipmentProducts } = require('../../shipment/tools/bulk-translate-shipment-products')
const { parse: parseSmartId } = require('../../tools/smart-id')
const offline = require('../../shipment/tools/offline')

// Sum quantities received at `locationId` whose delivery (received) date
// falls inside the reporting period's effective window. Keyed by product id.
//
// Only the shipment's `received` snapshot date determines inclusion.
// Shipments received outside the window are excluded even if they were ordered inside it, and vice-versa.
module.exports = async function getPeriodShipmentStock (state, {
  locationId,
  service,
  period
}) {
  const startDate = new Date(period.effectiveStartDate).toJSON()
  const endDate = new Date(period.effectiveEndDate).toJSON()

  let shipments
  try {
    shipments = await findShipment(
      state,
      { location: locationId, startdate: startDate, enddate: endDate },
      { checkSnapShotLocation: true }
    )
  } catch (error) {
    if (error && error.status === offline.OFFLINE_ERROR) {
      return {}
    }
    throw error
  }

  if (!shipments || !shipments.length) {
    return {}
  }

  const { products } = await listForLocations(state, [locationId], {
    date: endDate,
    serviceId: service.id,
    exclude: '',
    idsOnly: false
  })
  const productList = Object.values(products)
  const location = { id: locationId }

  return shipments.reduce((acc, shipment) => {
    if (!isInboundReceivedInWindow(shipment, locationId, startDate, endDate)) {
      return acc
    }

    const { translatedCounts } = bulkTranslateShipmentProducts(state, {
      shipment,
      location,
      products: productList,
      service
    })

    for (const batchId of Object.keys(translatedCounts || {})) {
      const quantity = deepGet(translatedCounts, [batchId, 'quantity'], 0)
      if (!quantity) continue

      const { product } = parseSmartId(batchId)
      const productId = `product:${product}`
      acc[productId] = (acc[productId] || 0) + quantity
    }

    return acc
  }, {})
}

function isInboundReceivedInWindow (shipment, locationId, startDate, endDate) {
  if (!shipment || !shipment.destination || shipment.destination.id !== locationId) {
    return false
  }

  const receivedDate = deepGet(shipment, 'snapshotDates.received')
  if (!receivedDate) return false

  return receivedDate >= startDate && receivedDate <= endDate
}
